import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import Header from '../../atoms/Header/Header'
import Section from '../../atoms/Section/Section'
import PropTypes from 'prop-types'
import React from 'react'
import getCloudinaryID from '../../../utils/getCloudinaryID'
import { Helmet } from 'react-helmet'

const sizes = {
  small: '300px',
  medium: '500px',
  large: '630px'
}
const DEFAULT_HERO_IMAGE =
  'https://res.cloudinary.com/rehabpath/image/upload/v1631895914/assets/default-hero.png'

const Style = styled.div`
  height: ${(props) => sizes[props.size]};
  .hero {
    width: 100vw;
    height: ${(props) => sizes[props.size]};
    ${media.lessThan('medium')`
		height: 220px;
	`} position: relative;
    background-position: center;
    background-size: cover;
    .overlay {
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.9)
      );
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: absolute;
      height: 100%;
      top: 0;
      & > * {
        ${(props) =>
          props.blog
            ? css`
                max-width: 780px;
                & > * {
                  text-align: left;
                  ${media.lessThan('medium')`
          text-align: center;
          line-height: 40px;
          padding: 10%;
          font-size: 30px;
        `}
                }
              `
            : ''}
      }
    }
  }

  ${media.lessThan('medium')`
  height: 220px;;
`};
  ${(props) =>
    props.hideOnMobile &&
    `
    @media only screen and (max-width: 770px) {
        display: none;
}
  
  `};
`
const BackgroundImage = styled.img`
  z-index: -1;
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Hero = ({
  hideOnMobile,
  title,
  noOverlay,
  size,
  children,
  background,
  blog
}) => {
  const id = getCloudinaryID(background)

  let widths = [3200, 2800, 2400, 2000, 1600, 1400, 1200, 1000, 800, 600, 400]
  let height = 800

  const src = `https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_${height},w_${widths[0]}/${id}`

  const srcSet = widths
    .map(
      (width) =>
        `https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_webp,h_${height},w_${width}/${id} ${width}w`
    )
    .join(', ')

  return (
    <Style
      hideOnMobile={hideOnMobile}
      size={size}
      blog={blog}
    >
      <Helmet>
        <link
          rel="preload"
          as="image"
          href={id ? src : DEFAULT_HERO_IMAGE}
          imageSrcSet={id ? srcSet : undefined}
          imageSizes="100vw" // indicate that the image is full-width
        />
      </Helmet>
      <div className="hero">
        <BackgroundImage
          srcSet={id ? srcSet : undefined}
          alt={title}
          sizes="100vw"
          fetchpriority="high"
        />
        {!noOverlay && <div className="overlay" />}
        <div className="content">
          {!children && title && (
            <div style={{ display: 'flex' }}>
              <Header
                align="center"
                display={2}
                as="h1"
                color="white"
              >
                {title}
              </Header>
            </div>
          )}
          {children}
        </div>
      </div>
      <Section />
    </Style>
  )
}

Hero.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  background: PropTypes.string,
  title: PropTypes.string,
  hideOnMobile: PropTypes.bool,
  noOverlay: PropTypes.bool,
  blog: PropTypes.bool,
  children: PropTypes.any
}

Hero.defaultProps = {
  size: 'medium'
}

export default Hero
